import { Badge, Box, Button, Card, Container, Group, Stack, Text, Title, useMantineTheme } from '@mantine/core';

import {
  IconArrowRight,
  IconExternalLink,
  IconFlowerOff,
  IconGift,
  IconGiftOff,
  IconHeart,
  IconMail,
} from '@tabler/icons-react';

import { motion } from 'framer-motion';

import { PRIMARY_FONT } from '../../constants/fonts';

export function GiftsSection() {
  const theme = useMantineTheme();
  return (
    <Box
      id="gifts"
      py={80}
      style={{
        backgroundColor: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background decorative elements */}
      <Box
        style={{
          position: 'absolute',
          top: '-10%',
          right: '-10%',
          width: '30%',
          height: '120%',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.03) 0%, transparent 70%)`,
          borderRadius: '50%',
          filter: 'blur(60px)',
        }}
      />
      <Box
        style={{
          position: 'absolute',
          bottom: '-10%',
          left: '-10%',
          width: '25%',
          height: '100%',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.02) 0%, transparent 70%)`,
          borderRadius: '50%',
          filter: 'blur(60px)',
        }}
      />

      <Container size="lg" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          viewport={{ once: true }}
        >
          <Stack align="center" gap="lg" mb={60}>
          <Badge
              size="lg"
              variant="light"
              color={theme.other.titleColor}
              style={{
                fontSize: '0.9rem',
                padding: '8px 16px',
                fontWeight: 500,
              }}
            >
              Prezenty weselne
            </Badge>

            <Title
              order={2}
              ta="center"
              style={{
                fontFamily: PRIMARY_FONT,
                fontSize: 'clamp(2.5rem, 6vw, 4rem)',
                fontWeight: 700,
                color: theme.other.titleColor,
                lineHeight: 1.2,
                marginBottom: '1rem',
              }}
            >
              Prezenty
            </Title>
          </Stack>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
          viewport={{ once: true }}
        >
          <Card
            radius="24"
            p="xl"
            style={{
              maxWidth: 700,
              margin: '0 auto',
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: `0 20px 40px rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.15), 0 8px 32px rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.1), 0 4px 16px rgba(0, 0, 0, 0.05)`,
            }}
          >
            <Stack gap="xl" align="center">
              {/* Modern visual flow */}
              <Stack gap="lg" align="center">
                {/* Icons row with modern styling */}
                <Group gap={40} align="center" justify="center" wrap="nowrap">
                  <Box
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: '16px',
                      background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0.7,
                    }}
                  >
                    <IconGiftOff size={32} color="white" />
                  </Box>

                  <Box
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: '16px',
                      background: 'linear-gradient(135deg, #f59e0b 0%, #eab308 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0.7,
                    }}
                  >
                    <IconFlowerOff size={32} color="white" />
                  </Box>
                </Group>
              </Stack>

              <Text
                size="lg"
                ta="center"
                style={{
                  color: '#6b7280',
                  lineHeight: 1.7,
                  maxWidth: 500,
                  fontSize: '1.1rem',
                  fontFamily: PRIMARY_FONT,
                }}
              >
                Wasza obecność będzie dla nas najpiękniejszym prezentem!
                Zamiast kwiatów i prezentów, wdzięczni będziemy za wsparcie w formie koperty.
              </Text>
            </Stack>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
}
